const screenerActionTypes = {
    SAVE_SCREENER_COLUMN_SETS: 'SAVE_SCREENER_COLUMN_SETS',
    SAVE_SCREENER_COLUMNS: 'SAVE_SCREENER_COLUMNS',
    SCAN_SECURITIES: 'SCAN_SECURITIES',
    SAVE_SCREENER_FIELDS: 'SAVE_SCREENER_FIELDS',
    SAVE_COLUMN_SET_OPTIONS: 'SAVE_COLUMN_SET_OPTIONS',
}

export default screenerActionTypes